<template>
  <div>
    <b-navbar
      toggleable="lg"
      :variant="getLayoutNavbarBg()"
      class="layout-navbar align-items-lg-center container-p-x"
    >
      <!-- Brand -->
      <b-navbar-brand to="/">
        <svg
          version="1.2"
          baseProfile="tiny"
          id="Layer_3"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 167.7 182.6"
          xml:space="preserve"
          height="40"
        >
          <g>
            <path
              fill="#BB4230"
              d="M133.2,36.7c-2.2-7.9-5-15.5-11-21.5c-5.6-5.7-12-5.2-17,1.1c-2.6,3.3-4.6,6.9-6.4,10.7c-1.6-1.4-1.7-3.3-2.4-4.9c-2.4-5.9-5.1-11.6-9.7-16.1c-5.2-5.1-11-5.3-16.3-0.4C63,12.3,60,21.5,57.4,30.8c-9.7,34.9-10,70.3-3.7,105.8C55.9,149,59,161.4,66.2,172c7.4,10.9,16.3,12,24.2,0.2c2.6-3.9,4.7-8,6.3-12.4c0.5-1.3,0.5-2.9,2.1-3.8c1.7,3.8,3.7,7.5,6.2,10.8c4.9,6.4,11.2,6.9,17,1.3c3.7-3.5,6-7.9,7.9-12.5c5-12.1,7.3-24.8,8.6-37.7C141.5,90.4,140.7,63.3,133.2,36.7z M94.4,154.2c-2.3,1.6-4.4,3.5-7.7,2.2c-6-2.4-8.8-7.4-10.9-12.8c-6.8-17.3-8.5-35.5-8.4-53.9c0.1-17.3,1.9-34.5,8.4-50.9c1.6-4,3.8-7.7,7-10.8c1.9-1.7,4.1-1.9,5.8-2.6c4.8,0.1,8.6,4.7,7.5,8.6c-10.6,38.2-10.6,76.5-0.1,114.7C96.7,151.1,96.5,152.8,94.4,154.2z M131.2,126.4c-1.6,4.2-2.8,9.9-8.5,9.8c-5.8-0.1-7.2-5.6-8.9-10c-4.2-11.2-4.8-23-4.9-34.9c0.1-12,0.8-24,5.2-35.3c1.6-4.2,3.3-9.3,8.4-9.5c5.1-0.2,6.6,4.9,8.3,8.8c3,6.9,4.3,14.3,4.9,21.8C137.1,93.8,137,110.5,131.2,126.4z"
            />
          </g>
          <path
            fill="#BB4230"
            d="M55.2,168.6C28.7,158.5,1.7,128.3,1.9,90.1C2,54,28.5,23.8,55.6,13.1C35.7,35.2,27,61.4,27.1,90.7C27.1,120,35.3,146.4,55.2,168.6z"
          />
          <path
            fill="#BB4230"
            d="M166.2,90.7c-0.4,6.5-0.8,12.9-3.1,19.1c-0.8,2.2-1.7,4.7-4.5,4.7c-2.6,0-3.6-2.4-4.2-4.4c-4.1-13-4.1-26.2,0-39.2c0.6-2,1.7-4.4,4.2-4.4c2.9-0.1,3.7,2.5,4.5,4.6C165.4,77.3,165.8,84,166.2,90.7z"
          />
        </svg>
        <span class="text-danger e-eng-font demo e-light-bold ml-2 e-ts-h5"
          >&nbsp; ScreeningHub</span
        >
      </b-navbar-brand>

      <!-- Sidenav toggle -->
      <b-navbar-nav
        class="align-items-lg-center mr-auto mr-lg-4"
        v-if="sidenavToggle"
      >
        <div
          class="nav-item d-none d-lg-block text-big font-weight-light line-height-1 opacity-25 mr-3 ml-1"
        >
          |
        </div>
        <a
          class="nav-item nav-link px-0 ml-2 ml-lg-0"
          href="javascript:void(0)"
          @click="toggleSidenav"
        >
          <i class="ion ion-md-menu text-large align-middle" />
        </a>
      </b-navbar-nav>

      <!-- Navbar toggle -->
      <b-navbar-toggle target="app-layout-navbar"></b-navbar-toggle>
      <div
        class="nav-item d-none d-lg-block text-big font-weight-light line-height-1 opacity-50"
      >
        |
      </div>
      <b-collapse is-nav id="app-layout-navbar">
        <b-navbar-nav class="align-items-lg-center">
          <b-nav-item to="/Aml/Requests" :exact="true" class="e-mtavr-17"
            >სქრინინგი</b-nav-item
          >
          <b-nav-item
            to="/System/ScanningSettings"
            class="e-mtavr-17"
            :exact="true"
            >სისტემა</b-nav-item
          >
        </b-navbar-nav>
      </b-collapse>
      <!-- ნოტიფიკაციების დასაწყისი -->
      <b-navbar-nav class="align-items-lg-center ml-auto mr-lg-5">
        <b-nav-item>
          {{searchesinfo.aboutToExpire}}
          <span class="e-nusx-6 text-danger" v-if="searchesinfo.searchCountAvaibled < searchesinfo.searchCountPurchased /33"> იწურება თქვენს მიერ შეძენილი კლიკების რაოდენობა!</span>
          <br v-if="searchesinfo.searchCountAvaibled < searchesinfo.searchCountPurchased /33"/>
          <span class="e-nusx-6 text-danger" v-if="isAboutToExpire"> იწურება თქვენს მიერ შეძენილი კლიკებით სარგებლობის ვადა! </span>
          <span class="e-nusx-6 text-danger" v-if="isServiceDisabled"> სქრინინგის სერვისი გათიშულია! </span>
          <!-- {{ notificationsInfo }} -->
        </b-nav-item>
        <b-nav-item>
          <div class="media align-items-center">
          <div class="ion ion-logo-googleplus text-google text-large"></div>
          <div class="media-body ml-3">
            <div class="text-big font-weight-bold line-height-1">{{searchesinfo.searchCountPurchased}}</div>
            <div class="text-light text-tiny font-weight-semibold line-height-1 mt-1 e-mtavr-17">სულ შეძენილი</div>
          </div>
        </div>
        </b-nav-item>
        <b-nav-item>
          <div class="media align-items-center">
          <div class="ion ion-logo-googleplus text-google text-large"></div>
          <div class="media-body ml-3" :class="[searchesinfo.searchCountAvaibled < searchesinfo.searchCountPurchased /10 ? 'text-danger' : '']">
            <div class="text-big font-weight-bold line-height-1">{{searchesinfo.searchCountAvaibled}}</div>
            <div class="text-light text-tiny font-weight-semibold line-height-1 mt-1 e-mtavr-17">დარჩენილია</div>
          </div>
        </div>
        </b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="align-items-lg-center ml-auto">
        <b-nav-item-dropdown
          no-caret
          :right="!isRtlMode"
          class="e-navbar-notifications mr-lg-3"
        >
          <template slot="button-content">
            <i class="lnr lnr-alarm navbar-icon align-middle"></i>
            <span class="badge badge-primary badge-dot indicator" v-if="this.unreadNotifCount > 0 || this.unreadSysNotifCount > 0"></span>
            <span class="d-lg-none align-middle e-nusx-8"
              >&nbsp; შეტყობინებები</span
            >
          </template>

          <div
            class="bg-primary text-center text-white font-weight-bold p-3 e-eng-font"
          >
            {{ unreadNotifCount }}
            <span class="e-mtavr-17">ახალი შეტყობინება</span>
          </div>
          <div class="overflow-auto g-max-height-70vh">
          <b-list-group flush>
            <b-list-group-item
              href="javascript:void(0)"
              v-on:click="OpenNotfItem(nt)"
              class="media d-flex align-items-center"
              v-for="nt in notificationsInfo"
              :key="nt.$index"
            >
              <div
                class="ui-icon ui-icon-sm border-0 text-white"
                :class="{ 'bg-primary lnr lnr-sync': nt.typeId === 1,  'bg-warning lnr lnr-database': nt.typeId === 3}"
              ></div>
              <div class="media-body line-height-condenced ml-3">
                <div
                  class="text-body"
                  :class="{
                    'e-bold': nt.statusId === 2,
                    'text-muted': nt.statusId != 2,
                  }"
                >
                  {{ nt.title }}
                </div>
                <div class="text-light small mt-1">
                  {{ nt.shortMessage }}
                </div>
                <div class="text-light small mt-1">
                  <small>{{ nt.recDateST }}</small>
                </div>
              </div>
            </b-list-group-item>

            <!-- <b-list-group-item href="javascript:void(0)" class="media d-flex align-items-center">
              <div class="ui-icon ui-icon-sm lnr lnr-sync bg-info border-0 text-white"></div>
              <div class="media-body line-height-condenced ml-3">
                <div class="text-body e-mtavr-15">სისტემური განახლება</div>
                <div class="text-light small mt-1 e-nusx-8">
                  მოხდა სისტემური განახლება. სისტემის ახალი ვერსია <span class="e-eng-font e-bold">v 1.0.1</span>
                </div>
              </div>
            </b-list-group-item>

            <b-list-group-item href="javascript:void(0)" class="media d-flex align-items-center">
              <div class="ui-icon ui-icon-sm ion ion-md-power bg-danger border-0 text-white"></div>
              <div class="media-body line-height-condenced ml-3">
                <div class="text-body">სისტემური შეფერხება</div>
                <div class="text-light small mt-1">
                  19h ago
                </div>
              </div>
            </b-list-group-item>

            <b-list-group-item href="javascript:void(0)" class="media d-flex align-items-center">
              <div class="ui-icon ui-icon-sm ion ion-md-warning bg-warning border-0 text-body"></div>
              <div class="media-body line-height-condenced ml-3">
                <div class="text-body">99% server load</div>
                <div class="text-light small mt-1">
                  Etiam nec fringilla magna. Donec mi metus.
                </div>
                <div class="text-light small mt-1">
                  20h ago
                </div>
              </div>
            </b-list-group-item> -->
          </b-list-group>
          </div>
          <a
            href="javascript:void(0)"
            class="d-block text-center text-light small p-2 my-1 e-mtavr-17"
            >ყველა შეტყობინება</a
          >
        </b-nav-item-dropdown>
      </b-navbar-nav>
      <!-- ნოტიფიკაციების დასასრული -->
      <b-navbar-nav class="align-items-lg-center ml-auto">
        <!-- Divider -->
        <div
          class="nav-item d-none d-lg-block text-big font-weight-light line-height-1 opacity-50 mr-3 ml-1"
        >
          |
        </div>

        <b-nav-item-dropdown :right="!isRtlMode" class="demo-navbar-user">
          <template slot="button-content">
            <span
              class="d-inline-flex flex-lg-row-reverse align-items-center align-middle"
            >
              <i class="lnr d-block lnr-user"></i>
              <span class="px-1 mr-lg-2 ml-2 ml-lg-0"
                >{{ currentUser.firstName }} {{ currentUser.lastName }}</span
              >
            </span>
          </template>

          <!-- <b-dd-item><i class="ion ion-ios-person text-lightest"></i> &nbsp; My profile</b-dd-item>
          <b-dd-item><i class="ion ion-ios-mail text-lightest"></i> &nbsp; Messages</b-dd-item>
          <b-dd-item><i class="ion ion-md-settings text-lightest"></i> &nbsp; Account settings</b-dd-item>
          <b-dd-divider />-->
          <b-dd-item class="e-nusx-8" to="/" :exact="true"
            ><i class="lnr lnr-exit text-danger"></i> &nbsp; გასვლა</b-dd-item
          >
          <!-- <b-dd-item class="e-nusx-8" @click="testrefresh()" :exact="true"><i class="ion ion-ios-log-out text-danger"></i> &nbsp; გასვლა</b-dd-item> -->
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-navbar>

    <notification-item :notificationItem="ntfData"></notification-item>
  </div>
</template>
<style src="../vendor/styles/icons.scss" lang="scss"></style>
<script>
import notificationItem from '../components/Aml/components/notificationItem'
import BaseService from '@/backend/vue-axios/axios.js'
import moment from 'moment'
export default {
  name: 'app-layout-navbar',
  components: {
    notificationItem
  },
  data () {
    return {
      isAboutToExpire: false,
      isServiceDisabled: false,
      searchesinfo: {},
      currentUser: {},
      unreadnotcount: 0,
      unreadsysnotcount: 0,
      unrdnotcount: 0,
      unrdsysnotcount: 0,
      notifications: [],
      ntfData: {},
      header: {
        headers: {
          accept: 'text/plain',
          Authorization: 'Bearer ' + this.$store.getters.getAccessToken
        }
      }
    }
  },
  computed: {
    ctr () { return this.$store.state.preloadedData.searchesInfo },
    user () {
      return this.$store.state.authentication.user
    },
    users () {
      return this.$store.state.users.all
    },
    notificationsInfo () {
      return this.$store.getters.GetNotificationData
    },
    unreadNotifCount () {
      return this.$store.getters.GetUnreadNotiCount
    },
    unreadSysNotifCount () {
      return this.$store.getters.GetUnreadSysNotiCount
    }
  },
  created () {
    this.currentUser = this.$store.getters.GetCurrentUser
    this.notifications = this.notificationsInfo
    this.unreadnotcount = this.unreadNotifCount
    this.unreadsysnotcount = this.unreadSysNotifCount
  },
  props: {
    sidenavToggle: {
      type: Boolean,
      default: true
    }
  },
  beforeCreate: function () {
    // this.$store.dispatch('users/getAll')
    const RequestGeneralData = {
      headers: {
        accept: 'text/plain',
        Authorization: 'Bearer ' + this.$store.getters.getAccessToken
      }
    }
    BaseService.GetPreparationData(RequestGeneralData).then((res) => {
      // console.log(res.data)
      this.$store.commit('setActiveUsersList', res.data.result.activeUsers)
      this.$store.commit('setCurrentUserDetails', res.data.result.user)
      this.$store.commit('setCountryList', res.data.result.countries)
      this.$store.commit(
        'setjuridicalStatuses',
        res.data.result.juridicalStatuses
      )
      this.$store.commit(
        'setscannigPacketDatabases',
        res.data.result.scannigPacketDatabases
      )
      this.$store.commit('setscanningPackets', res.data.result.scanningPackets)
      this.$store.commit('setscanningTypes', res.data.result.scanningTypes)
      this.$store.commit('setRequestStatuses', res.data.result.requestStatuses)
      this.$store.commit(
        'setNotificationTypes',
        res.data.result.notificationTypes
      )
      this.$store.commit(
        'setNotificationStatuses',
        res.data.result.notificationStatuses
      )
      this.$store.commit(
        'setPurchasedScanningPacket',
        res.data.result.purchasedScanningPacket
      )
      // localStorage.setItem('CurrentUserDetails', JSON.stringify(res.data.result.user))
      this.$store.commit('setDecisionTypes', res.data.result.decisionResultTypes)
    })
    BaseService.GetNotifications(RequestGeneralData)
      .then((res) => {
        // console.log(res.data)
        function compare (a, b) {
          if (a.statusId < b.statusId) {
            return 1
          }
          if (a.statusId > b.statusId) {
            return -1
          }
          return 0
        }
        if (res.data.success) {
          // console.log(res)
          for (var i = 0, len = res.data.result.length; i < len; i++) {
            if (
              res.data.result[i].typeId === 1 &&
              res.data.result[i].statusId === 2
            ) {
              this.unrdsysnotcount = this.unrdsysnotcount + 1
            }
            if (res.data.result[i].statusId === 2) {
              this.unrdnotcount = this.unrdnotcount + 1
            }
            res.data.result[i].recDateST = moment(
              res.data.result[i].recDate
            ).format('DD.MM.YYYY HH:mm')
          }
          if (this.unrdsysnotcount > 0) {
            this.$notify({
              group: 'e-notifications-alert',
              title: 'შეტყობინება',
              text:
                'თქვენ გქვთ ' +
                this.unrdsysnotcount +
                ' ახალი სისტემური შეტყობინება, გთხოვთ გაეცნოთ და მოახდინოთ შესაბამისი რეაგირება.',
              width: '500',
              duration: '1'
            })
          } else if (this.unrdnotcount > 0) {
            this.$notify({
              group: 'e-notifications-alert',
              title: 'შეტყობინება',
              text:
                'მონაცემთა ბაზაში მოხდა განახლება, გთხოვთ გაეცნოთ შეტყობინებას და მოახდინოთ შესაბამისი რეაგირება.',
              width: '500',
              duration: '1'
            })
          }
        } else {
          return null
        }
        // this.notifications = res.data.result.sort(compare)
        this.$store.commit('setNotificationData', res.data.result.sort(compare))
        this.$store.commit('setUnreadNotCount', this.unrdnotcount)
        this.$store.commit('setUnreadSysNotCount', this.unrdsysnotcount)
      })
      .catch((error) => {
        console.log(error)
        //   this.$swal({
        //     title: 'ყურადღება!',
        //     text:
        //           'შეტყობინებების ჩატვირთვისას მოხდა სისტემური შეცდომა:' + error,
        //     type: 'warning',
        //     showCancelButton: false,
        //     confirmButtonColor: '#DD6B55',
        //     confirmButtonText: 'თანხმობა',
        //     heightAuto: false,
        //     customClass: 'e-nusx-8',
        //     confirmButtonClass: 'e-mtavr-17',
        //     keydownListenerCapture: true
        //   }).then(result => {
        //     if (result.value) { this.$router.replace(this.$route.query.redirect || '/Auth') }
        //   })
      })
    BaseService.GetSearchesInfo(RequestGeneralData)
      .then(res => {
        if (res.data.success) {
          var date1 = moment()
          var date2 = moment(res.data.result.endDate).utc()
          if (date2.diff(date1, 'days') < 10 && date2.diff(date1, 'days') > 0) {
            this.isAboutToExpire = true
          }
          if (date2.diff(date1, 'days') < 0) {
            this.isServiceDisabled = true
          }
          this.$store.commit('setSearchesInfo', res.data.result)
          // this.searchesinfo = res.data.result
        }
      })
  },
  watch: {
    ctr (nv) {
      this.searchesinfo = nv
    }
  },
  // watch: {
  //   '$store.state.preloadedData.searchesInfo.searchCountAvaibled': {
  //     handler: function (nv) {
  //       this.this.searchesinfo = nv
  //     },
  //     immediate: true // provides initial (not changed yet) state
  //   }
  // },
  methods: {
    // GetSearchesInfo () {

    // },
    ChangeNtfStatus () {
    },
    OpenNotfItem (data) {
      this.ntfData = data
      this.$bvModal.show('ShowNotfItem')
    },
    toggleSidenav () {
      this.layoutHelpers.toggleCollapsed()
    },

    getLayoutNavbarBg () {
      return this.layoutNavbarBg
    }
  }
}
</script>
